import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import {NotFound} from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const AccountMappingView = Loadable({
    loader: () => import("~/views/admin/account/AccountMapping"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/mapping`} component={AccountMappingView} />
        <Route component={NotFound} />
    </Switch>
);